// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
require('es6-promise').polyfill();

import Vue from 'vue';
import Configurator from './components/Configurator.vue';
import App from './App.vue';
import VueResource from 'vue-resource';
import VueCookie  from 'vue-cookie';
import VueScrollTo from 'vue-scrollto';
import VueObserveVisibility from 'vue-observe-visibility';

Vue.use(VueScrollTo);
Vue.use(VueCookie);
Vue.use(VueResource);
Vue.use(VueObserveVisibility);
Vue.http.options.emulateJSON = true;
Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.component('configurator', Configurator);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    template: '<App/>',
    components: {
        App,
    },
});



// WEBPACK FOOTER //
// ./src/main.js